import React from 'react';
import Script from 'react-load-script';

import Segment from '../../../../components/Segment';

const segment = new Segment();

export default function(wistiaId = 'j38ihh83m5', advisor = {}) {
  const advisorProps = {
    id: advisor.id,
    email: advisor.email,
    first_name: advisor.first_name,
    last_name: advisor.last_name,
  };

  class WistiaHOC extends React.Component {
    state = {
      jsonpLoaded: false,
      jsLoaded: false,
      wistiaLoaded: false,
    };

    componentDidUpdate(prevProps, prevState) {
      const didWistiaLoad =
        !prevState.wistiaLoaded && !!this.state.wistiaLoaded;
      if (didWistiaLoad) {
        console.log('WISTIA LOADED');
        this.setupWistia();
      }
    }

    setupWistia() {
      window._wq = window._wq || [];
      window._wq.push({
        id: '_all',
        onReady: function(video) {
          // for all existing and future videos, run this function
          video.bind('play', function() {
            const videoProps = {
              id: video.hashedId(),
              duration: video.duration(),
              secondsWatched: video.secondsWatched(),
              percentWatched: video.percentWatched(),
            };
            segment.track('step6_advisor_video_play', {
              ...videoProps,
              ...advisorProps,
            });

            // when one video plays, iterate over all the videos and pause each,
            // unless it's the video that just started playing.
            var allVideos = window.Wistia.api.all();
            for (var i = 0; i < allVideos.length; i++) {
              if (allVideos[i].hashedId() !== video.hashedId()) {
                allVideos[i].pause();
              }
            }
          });

          video.bind('pause', function() {
            const videoProps = {
              id: video.hashedId(),
              duration: video.duration(),
              secondsWatched: video.secondsWatched(),
              percentWatched: video.percentWatched(),
            };
            segment.track('step6_advisor_video_pause', {
              ...videoProps,
              ...advisorProps,
            });
          });

          video.bind('end', function() {
            const videoProps = {
              id: video.hashedId(),
              duration: video.duration(),
              secondsWatched: video.secondsWatched(),
              percentWatched: video.percentWatched(),
            };
            segment.track('step6_advisor_video_end', {
              ...videoProps,
              ...advisorProps,
            });
          });
        },
      });
    }

    handleJsonpLoaded = () => {
      this.setState({
        jsonpLoaded: true,
        wistiaLoaded: this.state.jsLoaded,
      });
    };

    handleJsLoaded = () => {
      this.setState({
        jsLoaded: true,
        wistiaLoaded: this.state.jsonpLoaded,
      });
    };

    render() {
      const { jsonpLoaded, jsLoaded } = this.state;
      const isLoaded = jsonpLoaded && jsLoaded;
      const style = {
        height: '100%',
        width: '100%',
      };

      if (wistiaId && !isLoaded) {
        return (
          <div style={style}>
            <Script
              url={`//fast.wistia.com/embed/medias/${wistiaId}.jsonp`}
              onLoad={this.handleJsonpLoaded}
            />
            <Script
              url="//fast.wistia.com/assets/external/E-v1.js"
              onLoad={this.handleJsLoaded}
            />
          </div>
        );
      }

      console.log('RENDER', wistiaId);

      return (
        <div className={`wistia_embed wistia_async_${wistiaId}`} style={style}>
          &nbsp;
        </div>
      );
    }
  }

  return WistiaHOC;
}



// WEBPACK FOOTER //
// ./src/routes/assessment/components/CardAdvisor/WistiaHOC.js